//import Libraries
import React from 'react';

//import Components

import {orderStatus} from './constants/constants';

//import Styles
import './Order.css'
import company from '../../Home/Company/Company';

const order = ({order, account, products, checked, handleOnChange, index}) => {

    const getClassName = (status) => {
        switch(status) {
            case orderStatus[0]: {
                return 'doing'
            }break;
            case orderStatus[1] : {
                return 'delivering'
            }break;
            case orderStatus[2] : {
                return 'return';
            }break;
            case orderStatus[3] : {
                return 'done'
            }break;
            default : {
                return null;
            }break;
        }
    }

    const {orderTime, status, message, cart} = order;
    let {fullName, company} = account;
 

    let orderedProductsIndex = [];    
    let orderedProductsTypeIndex = [];

    let productsName = [];
    let productsType = [];
    let productsQuantity = [];

    const cartArray = Object.values(cart);
    cartArray.map(item => {
        orderedProductsIndex.push(products.findIndex(product => {
            return (product.id === item.id);
        }));
        orderedProductsTypeIndex.push(item.typeIndex);
        productsQuantity.push(item.quantity);
    })

    orderedProductsIndex.map((i, index) => {
        if(i !== -1){

            productsName.push(products[i].name);
            productsType.push(products[i].types[orderedProductsTypeIndex[index]]);
        }
    })

    const className = getClassName(status);

    return (
            <tr>
                <td>
                    <input type="checkbox" name={`${index}`} checked={checked} onChange={handleOnChange} />
                </td>
                <td>{fullName}</td>
                <td>{company}</td>
                <td>{`${orderTime.day.year}.${orderTime.day.month}.${orderTime.day.date} - ${orderTime.time.hour}:${orderTime.time.minute}:${orderTime.time.second}`}</td>
                <td>
                {
                    productsName.map((name, index) => {
                        return (
                            <div key={index}>
                                {`${name['ko']} - ${productsType[index]}`}
                            </div>
                        );
                    })     
                }
                </td>
                <td>
                {
                    productsQuantity.map((quantity, index) => {
                        return (
                            <div key={index}>
                                {quantity}
                            </div>
                        )
                    })
                }
                </td>
                <td className={className}>{status}</td>
                <td>{message}</td>
            </tr>
    );
}

export default order;


// WEBPACK FOOTER //
// ./src/pages/Admin/OrderManager/Order.js